'use client'
import React, { HTMLAttributes, ReactElement } from 'react'
import { LayoutContentPaneType } from './types-and-constants/LayoutPaneTypesAndConstants'
import { getRetainBehaviorModifierForPane } from '../helpers/get-retain-behavior-for-pane'
import { useLayoutContext } from '../../../../providers'
import { Retain } from '../../../atoms/Retain/Retain'
import { RetainBehaviorModifier } from '../../../atoms/Retain/constants/modifiers'

interface Props extends HTMLAttributes<HTMLDivElement> {
    paneType: LayoutContentPaneType
    children: ReactElement[] | ReactElement
    customRetainBehaviorModifier?: RetainBehaviorModifier
    fillAvailableHeight?: boolean
}

/**
 * @deprecated Prefer LayoutContentPaneRSC
 * */
export const LayoutContentPane = ({
    paneType,
    children,
    customRetainBehaviorModifier,
    fillAvailableHeight = true,
    ...props
}: Props): ReactElement => {
    if (paneType !== LayoutContentPaneType.CONTENT) {
        console.error('LayoutContentPane must be LayoutPaneType.CONTENT for the Layout to read it.')
    }

    const layoutContext = useLayoutContext()

    return (
        <div {...props} className={`o-layout__content ${props.className ?? ''}`.trim()}>
            <Retain
                behaviorModifiers={[
                    customRetainBehaviorModifier ?? getRetainBehaviorModifierForPane(paneType, layoutContext),
                ]}
                className={fillAvailableHeight ? 'h-full' : 'h-auto'}
                behaviorOnly
            >
                {children}
            </Retain>
        </div>
    )
}
